<template>
    <div>
        <section class="page-title-area d-flex align-items-center bg_cover"
                 style="background-image: url('/images/page-title-bg.jpg')">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="page-title-item text-center">
                            <h3 class="title">Login</h3>
                            <nav aria-label="breadcrumb">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item">
                                        <router-link to="/">Home</router-link>
                                    </li>
                                    <li class="breadcrumb-item active" aria-current="page">Login</li>
                                </ol>
                            </nav>
                        </div> <!-- page title item -->
                    </div>
                </div> <!-- row -->
            </div> <!-- row -->
            <div class="page-title-shape">
                <img src="/images/banner-shape.png" alt="shape">
            </div> <!-- page title shape -->
        </section>
        <section class="contact-touch-area pt-85 pb-90">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-9">
                        <div class="contact-touch-part">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="secton-title text-center">
                                        <h5 class="title">Login to your account</h5>
                                        <p>Join other 2000+ users!</p>
                                    </div>
                                </div>
                            </div>
                            <form id="contact-form" @submit.prevent="login" autocomplete="off">
                                <h3>Reset Password</h3>
                                <div class="alert squares alert-danger" v-if="invalid">
                                    <p style="color: red;">Email Invalid.</p>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="input-box mt-35">
                                            <label>Email</label>
                                            <input v-model="form.email" type="email" class="form-control">
                                            <small style="color: red" v-if="error && errors.email">{{ errors.email[0] }}</small>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="input-box mt-35">
                                            <label>Enter new password</label>
                                            <input v-model="form.password" type="password" class="form-control">
                                            <small style="color: red" v-if="error && errors.password">{{ errors.password[0] }}</small>

                                        </div>
                                    </div>
                                        <div class="col-lg-6">
                                            <div class="input-box mt-35">
                                                <label>Repeat password</label>
                                                <input v-model="form.confirmpassword" type="password" class="form-control">
                                                <small style="color: red" v-if="error && errors.password">{{ errors.password[0] }}</small>
                                            </div>
                                        </div>
                                    <div class="col-lg-12">
                                        <div class="input-box mt-35 text-center">
                                            <button @click.prevent="change()">Submit</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div class="vld-parent">
            <loading :active.sync="isLoading"
                     :can-cancel="true"
                     :is-full-page="fullPage"></loading>
        </div>
    </div>
</template>

<script>
    import Loading from "vue-loading-overlay";
    import "vue-loading-overlay/dist/vue-loading.css";
    export default {
        name: "ResetPassword",
        components: {
            Loading
        },
        data(){
            return{
                token: this.$route.params.token,
                error: false,
                errors: {},
                invalid: false,
                isLoading: false,
                fullPage: true,
                form:{
                    email: '',
                    password: '',
                    confirmpassword:''
                }
            }
        },
        methods:{
            change(){
                this.isLoading = true;
                this.error = false;
                this.invalid = false;

                this.axios.post('password/reset',{
                    email: this.form.email,
                    password: this.form.password,
                    password_confirmation: this.form.confirmpassword,
                    token:this.token
                })
                    .then(response=>{
                        this.isLoading = false;
                        this.$swal.fire({
                            icon: 'success',
                            title: 'Success',
                            text: 'Password Reset'
                        })
                            .then(()=>{
                                this.$router.push('/login');
                            })
                    })
                    .catch(error => {
                        this.isLoading = false;
                        this.error = true;

                        if (error.response.data.errors) {
                            this.error = true;
                            this.errors = error.response.data.errors;
                        }

                        if (error.response.data.error) {
                            this.invalid = true;
                            this.errors = error.response.data.error;
                        }
                    })

            }
        }
    }
</script>

<style scoped>

</style>